import './reports.css';

export const Ordered: React.FC = () => <></>;
